export enum PortfolioState {
  Active = 'ACTIVE',
  Pending = 'PENDING',
}
